import Fetcher from 'libs/fetcher';

const fetcher = new Fetcher();

export async function createOrganization(data) {
  return fetcher.post({
    path: '/organizations',
    body: data,
  });
}

export async function updateOrganization(id, data) {
  // This is a rare case where we update the organization because we will get it from the token.
  return fetcher.put({
    path: '/organizations',
    body: data,
  });
}
